import { configureStore } from "@reduxjs/toolkit";
import UtilitySlice from "./features/UtilitySlice";
import globalRenderReducer from "./features/globalUtilitySlice";

const ReduxStore = configureStore({
  reducer: {
    UtilitySlice,
    globalRenderSlice: globalRenderReducer,
  },
});

export default ReduxStore;
